/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { DataTable, DataTableSortEvent } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Dialog } from "primereact/dialog";
import { RadioButton } from "primereact/radiobutton";
import { PaginatorPageChangeEvent } from "primereact/paginator";
import { AxiosResponse } from "axios";
import { toast } from "react-toastify";
import Loader from "../../../components/loader";
import PrimePaginator from "../../../components/prime-paginator";
import DeleteConfirmationDialog from "../../../components/delete-confirmation";
import { checkActionAuthorization, downloadCsvFile, IsFormValid, } from "../../../service/shared.service";
import { IsNullOrEmptyArray, IsStringNullEmptyOrUndefined, } from "../../../utils/null-check";
import { toastOptObj } from "../../../utils/constants";
import { APIResponseEntity } from "../../../interface/api-responce";
import { PaginateRespEntity } from "../../../interface";
import { APIToGetWorkStation, APIToCreateWorkStation, APIToUpdateWorkStation, APIToDeleteWorkStation, APIToExportWorkStation, APIToGetWorkStationDDL, APIToGetWorkCenterFilterDDL } from "../../../service/api-service";
import { DropdownOption, WorkStationDetailsEntity, WorkStationFilterRequest } from "../../../interface/production-master";
import { MultiSelect } from "primereact/multiselect";
const Status = [
    {
        name: "Active",
        code: true,
    },
    {
        name: "Inactive",
        code: false,
    },
];

function WorkStation() {
    const workCenterFilterRef = useRef<any>(null);
    const [status] = useState(["Active", "Inactive",]);
    const [selectedStatus, setSelectedStatus] = useState<string>("");
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [workStationDetails, setWorkStationDetails] = useState<WorkStationDetailsEntity[]>([]);
    const [totalPageCount, setTotalPageCount] = useState<number>(0);
    const [selectedWorkCenterFilters, setSelectedWorkCenterFilters] = useState<string[]>([]);
    const [tempWorkCenterFilters, setTempWorkCenterFilters] = useState<string[]>([]);
    const [filterReq, setFilterReq] = useState<WorkStationFilterRequest>({
        pageSize: 10,
        pageNumber: 0,
        sortColumn: "createdAt",
        sortOrder: "desc",
        codesearchText: "",
        namesearchText: "",
        workCenterIds: [],
        status: "",
        APICallCount: 0,
    });
    const [isDeleteRecordId, setIsDeleteRecordId] = useState<string>("");
    const [isWorkStationDialogVisible, setIsWorkStationDialogVisible,] = useState<boolean>(false);
    const [isEditMode, setIsEditMode] = useState<boolean>(false);
    const [selectedWorkStationId, setSelectedWorkStationId] = useState<string>("");
    const [workStationCode, setWorkStationCode] = useState<string>("");
    const [workStationName, setWorkStationName] = useState<string>("");
    const [selectedWorkCenterId, setSelectedWorkCenterId] = useState<string>("");
    const [workCenterOptions, setWorkCenterOptions] = useState<DropdownOption[]>([]);
    const [workCenterFilterOptions, setWorkCenterFilterOptions] = useState<DropdownOption[]>([]);
    const [workStationIsActive, setWorkStationIsActive] = useState<boolean>(true);
    const [submitted, setSubmitted] = useState<boolean>(false);
    const [formErrors, setFormErrors] = useState({
        code: "Please enter station code",
        name: "Please enter name",
        workCenter: "Please select work centre",
    });
    useEffect(() => {
        const delayDebounceFn = setTimeout(async () => {
            await fetchWorkStations();
        }, 300);
        return () => clearTimeout(delayDebounceFn);
    }, [filterReq]);

    useEffect(() => {
        fetchWorkCenterOptions();
        fetchWorkCenterFilterOptions();
    }, []);
    const fetchWorkStations = async (): Promise<void> => {
        setIsLoading(true);
        const reqObj = {
            pageNumber: filterReq.pageNumber,
            pageSize: filterReq.pageSize,
            sortOrder: filterReq.sortOrder,
            sortColumn: filterReq.sortColumn,
            codesearchText: filterReq.codesearchText,
            namesearchText: filterReq.namesearchText,
            workCenterIds: filterReq.workCenterIds,
            ...(!IsStringNullEmptyOrUndefined(
                filterReq.status
            ) && {
                status: filterReq.status,
            }),
        };
        try {
            const resp: AxiosResponse<APIResponseEntity> = await APIToGetWorkStation(reqObj);
            setWorkStationDetails([]);
            setTotalPageCount(0);
            if (resp && resp.data && resp.status === 200) {
                const axiosResp: APIResponseEntity = resp.data;
                if (axiosResp && axiosResp.data && axiosResp.status && axiosResp.statusCode === 200) {
                    const paginateResp: PaginateRespEntity = axiosResp.data;
                    setWorkStationDetails(paginateResp.data);
                    setTotalPageCount(paginateResp.totalCount);
                }
            } else {
                toast.error(resp?.data?.message || "Unable to get work stations", { ...toastOptObj, });
            }
        } catch (error) {
            toast.error("Unable to get work stations", { ...toastOptObj, });
        } finally {
            setIsLoading(false);
        }
    };
    const fetchWorkCenterOptions = async (): Promise<void> => {
        try {
            const resp: AxiosResponse<APIResponseEntity> = await APIToGetWorkStationDDL();
            if (resp && resp.data && resp.status === 200) {
                const axiosResp: APIResponseEntity = resp.data;
                if (axiosResp && axiosResp.data && axiosResp.statusCode === 200) {
                    const workCenterData = axiosResp.data.workCenter || [];
                    setWorkCenterOptions(
                        workCenterData.map(
                            (item: any) => ({
                                label: item.displayName,
                                value: item.id,
                            })
                        )
                    );
                }
            }
        } catch (error) {
            toast.error("Unable to get work centres", { ...toastOptObj, });
        }
    };

    const fetchWorkCenterFilterOptions = async (): Promise<void> => {
        try {
            const resp: AxiosResponse<APIResponseEntity> = await APIToGetWorkCenterFilterDDL();

            if (resp && resp.data && resp.status === 200) {
                const axiosResp: APIResponseEntity = resp.data;

                if (axiosResp && axiosResp.data && axiosResp.statusCode === 200) {
                    const workCenterData = axiosResp.data.workCenter || [];

                    setWorkCenterFilterOptions(
                        workCenterData.map((item: any) => ({
                            label: item.displayName,
                            value: item.id,
                        }))
                    );
                }
            }
        } catch (error) {
            toast.error("Unable to get work centres", {
                ...toastOptObj,
            });
        }
    };
    const onPageChange = (event: PaginatorPageChangeEvent): void => {
        setFilterReq(prev => ({
            ...prev,
            pageSize: event.rows,
            pageNumber: event.page,
            APICallCount: prev.APICallCount + 1,
        }));
    };
    const onTableSort = (event: DataTableSortEvent): void => {
        if (event && event.sortField && event.sortOrder) {
            setFilterReq(prev => ({
                ...prev,
                sortColumn: event.sortField as string,
                sortOrder: event.sortOrder === 1 ? "asce" : "desc",
                pageNumber: 0,
                APICallCount: prev.APICallCount + 1,
            }));
        }
    };
    const handleAdd = async (): Promise<void> => {
        setIsEditMode(false);
        setSelectedWorkStationId("");
        setWorkStationCode("");
        setWorkStationName("");
        setSelectedWorkCenterId("");
        setWorkStationIsActive(true);
        setSubmitted(false);
        setFormErrors({
            code: "Please enter station code",
            name: "Please enter name",
            workCenter: "Please select work centre",
        });
        setIsWorkStationDialogVisible(true);
    };
    const handleEdit = async (rowData: WorkStationDetailsEntity): Promise<void> => {
        if (!rowData || IsStringNullEmptyOrUndefined(rowData.id)) {
            return;
        }
        setSelectedWorkStationId(rowData.id);
        setWorkStationCode(rowData.code || "");
        setWorkStationName(rowData.name || "");
        setSelectedWorkCenterId(rowData.workCenterId || "");
        setWorkStationIsActive(rowData.isActive ?? true);
        setIsEditMode(true);
        setSubmitted(false);
        setFormErrors({
            code: "",
            name: "",
            workCenter: "",
        });
        setIsWorkStationDialogVisible(true);
    };
    const closeWorkStationDialog = (): void => {
        setIsWorkStationDialogVisible(
            false
        );
        setIsEditMode(false);
        setSelectedWorkStationId("");
        setWorkStationCode("");
        setWorkStationName("");
        setSelectedWorkCenterId("");
        setWorkStationIsActive(true);
        setSubmitted(false);
        setFormErrors({
            code: "Please enter station code",
            name: "Please enter name",
            workCenter: "Please select work centre",
        });
    };
    const deleteWorkStation = async (
        value: boolean
    ): Promise<void> => {
        if (!value) {
            return;
        }
        if (IsStringNullEmptyOrUndefined(isDeleteRecordId)) {
            return;
        }
        setIsLoading(true);
        try {
            const resp: AxiosResponse<APIResponseEntity> = await APIToDeleteWorkStation(isDeleteRecordId);
            if (resp && resp.data && resp.status === 200) {
                const axiosResp: APIResponseEntity = resp.data;
                if (axiosResp && axiosResp.data && axiosResp.status && axiosResp.statusCode === 200) {
                    toast.success(axiosResp.message, { ...toastOptObj, });
                    setIsDeleteRecordId("");
                    setFilterReq(prev => ({
                        ...prev,
                        pageNumber: 0,
                        APICallCount: prev.APICallCount + 1,
                    }));
                } else {
                    toast.error(axiosResp?.message || "Unable to retire work station", { ...toastOptObj, });
                }
            } else {
                toast.error(resp?.data?.message || "Unable to retire work station", { ...toastOptObj, });
            }
        } catch (error) {
            toast.error("Unable to retire work station", { ...toastOptObj, });
        } finally {
            setIsLoading(false);
        }
    };
    const actionIconTemplate = (rowData: WorkStationDetailsEntity) => {
        return (
            <ul className="tableIcon cursor-pointer action-icon-template-w">
                {checkActionAuthorization("update", "Work Station") && (
                    <li
                        data-toggle="tooltip"
                        title="Edit"
                    >
                        <img
                            src="assets/images/edit-icon.svg"
                            alt="Edit"
                            onClick={() => { handleEdit(rowData); }}
                        />
                    </li>
                )}

                {checkActionAuthorization("delete", "Work Station") && (
                    <li
                        data-toggle="tooltip"
                        title="Retire"
                        onClick={() => { setIsDeleteRecordId(rowData.id); }}
                    >
                        <DeleteConfirmationDialog isAccepted={deleteWorkStation} />
                    </li>
                )}
            </ul>
        );
    };
    const resetFilters = (): void => {
        setSelectedStatus("");
        setSelectedWorkCenterFilters([]);
        setTempWorkCenterFilters([]);
        setFilterReq(prev => ({
            ...prev,
            pageSize: 10,
            pageNumber: 0,
            sortColumn: "createdAt",
            sortOrder: "desc",
            codesearchText: "",
            namesearchText: "",
            workCenterIds: [],
            status: "",
            APICallCount:
                prev.APICallCount + 1,
        }));
    };
    const statusBodyTemplate = (rowData: WorkStationDetailsEntity) => {
        return (
            <span className={`badge badge-${rowData.isActive === true ? "success" : "danger"}`}            >
                {rowData.isActive ? "Active" : "Inactive"}
            </span>
        );
    };
    const codeFilterTemplate = () => {
        return (
            <InputText
                value={filterReq.codesearchText}
                placeholder="Search by station code"
                onChange={(e) =>
                    setFilterReq(prev => ({
                        ...prev,
                        codesearchText: e.target.value,
                        pageNumber: 0,
                        APICallCount: prev.APICallCount + 1,
                    }))
                }
            />
        );
    };

    const nameFilterTemplate = () => {
        return (
            <InputText
                value={filterReq.namesearchText}
                placeholder="Search by name"
                onChange={(e) =>
                    setFilterReq(prev => ({
                        ...prev,
                        namesearchText: e.target.value,
                        pageNumber: 0,
                        APICallCount: prev.APICallCount + 1,
                    }))
                }
            />
        );
    };

    const workCenterFilterTemplate = () => {
        return (
            <MultiSelect
                ref={workCenterFilterRef}
                value={tempWorkCenterFilters}
                options={workCenterFilterOptions}
                optionLabel="label"
                optionValue="value"
                placeholder="Select work centre"
                className="p-column-filter"
                maxSelectedLabels={1}
                filter
                resetFilterOnHide
                panelFooterTemplate={() => (
                    <div className="p-2">
                        <button
                            type="button"
                            className="p-button p-component p-button-sm"
                            onClick={() => {
                                setSelectedWorkCenterFilters(tempWorkCenterFilters);

                                setFilterReq(prev => ({
                                    ...prev,
                                    workCenterIds: tempWorkCenterFilters,
                                    pageNumber: 0,
                                    APICallCount: prev.APICallCount + 1,
                                }));

                                workCenterFilterRef.current.hide();
                            }}
                            disabled={
                                JSON.stringify([...tempWorkCenterFilters].sort()) ===
                                JSON.stringify([...selectedWorkCenterFilters].sort())
                            }
                        >
                            Apply
                        </button>
                    </div>
                )}
                onChange={(e) => {
                    setTempWorkCenterFilters(e.value);
                }}
                onHide={() => {
                    setTempWorkCenterFilters(selectedWorkCenterFilters);
                }}
            />
        );
    };

    const statusRowFilterTemplate = () => {
        return (
            <Dropdown
                value={selectedStatus}
                options={status}
                onChange={(e) => { handleChangeStatus(e.value); }}
                placeholder="Select status"
                className="p-column-filter"
                style={{ minWidth: "12rem", }}
            />
        );
    };

    const handleChangeStatus = (e: string): void => {
        setSelectedStatus(e);
        setFilterReq(prev => ({
            ...prev,
            status: e === "Active" ? "true" : e === "Inactive" ? "false" : "",
            pageNumber: 0,
            APICallCount: prev.APICallCount + 1,
        }));
    };
    const handleChange = (fieldName: string, value: string): void => {
        switch (fieldName) {
            case "code":
                setWorkStationCode(value);
                setFormErrors(prev => ({
                    ...prev,
                    code: IsStringNullEmptyOrUndefined(value.trim())
                        ? "Please enter station code"
                        : "",
                }));
                break;
            case "name":
                setWorkStationName(value);
                setFormErrors(prev => ({
                    ...prev,
                    name: IsStringNullEmptyOrUndefined(value.trim())
                        ? "Please enter name"
                        : "",
                }));
                break;
            default:
                break;
        }
    };

    const handleWorkCenterChange = (value: string): void => {
        setSelectedWorkCenterId(value);
        setFormErrors(prev => ({
            ...prev,
            workCenter:
                IsStringNullEmptyOrUndefined(
                    value
                )
                    ? "Please select work centre"
                    : "",
        }));
    };
    const handleSaveWorkStation = async (): Promise<void> => {
        setSubmitted(true);
        const isValid = IsFormValid(formErrors);
        if (!isValid) {
            return;
        }
        setIsLoading(true);
        try {
            let resp: AxiosResponse<APIResponseEntity>;
            if (isEditMode) {
                resp = await APIToUpdateWorkStation(selectedWorkStationId,
                    {
                        code: workStationCode.trim(),
                        name: workStationName.trim(),
                        workCenterId: selectedWorkCenterId,
                        isActive: workStationIsActive,
                    }
                );
            } else {
                resp =
                    await APIToCreateWorkStation(
                        {
                            code: workStationCode.trim(),
                            name: workStationName.trim(),
                            workCenterId: selectedWorkCenterId,
                        }
                    );
            }

            if (resp && resp.data) {
                const axiosResp: APIResponseEntity = resp.data;

                if (axiosResp && (axiosResp.statusCode === 200 || axiosResp.statusCode === 201)) {
                    toast.success(axiosResp.message, { ...toastOptObj, });
                    closeWorkStationDialog();
                    setFilterReq(prev => ({
                        ...prev,
                        pageNumber: 0,
                        APICallCount: prev.APICallCount + 1,
                    }));
                } else {
                    toast.error(axiosResp?.message || "Unable to save work station", { ...toastOptObj, });
                }
            }
        } catch (error) {
        } finally {
            setIsLoading(false);
        }
    };
    const fetchWorkStationCsvDetails = async (): Promise<void> => {
        setIsLoading(true);
        try {
            const resp: AxiosResponse<APIResponseEntity> = await APIToExportWorkStation();
            if (resp && resp.data && resp.status === 200) {
                const axiosResp: APIResponseEntity = resp.data;
                if (axiosResp && axiosResp.data && axiosResp.status && axiosResp.statusCode === 200) {
                    const excelUrl = axiosResp.data.xlsxUrl;
                    if (excelUrl && !IsStringNullEmptyOrUndefined(excelUrl)) {
                        const fileName = excelUrl.split("/").pop();
                        if (fileName && !IsStringNullEmptyOrUndefined(fileName)) {
                            await downloadCsvFile(excelUrl, fileName);
                        }
                    }
                }
            } else {
                toast.error(resp?.data?.message || "Unable to export work stations", { ...toastOptObj, });
            }
        } catch (error) {
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <Loader isLoading={isLoading} />
            <div className="content-wrapper">
                <div className="col-12">
                    <div className="row">
                        <div className="col-lg-12 col-md-12">
                            <div className="card card-rounded">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="row align-items-center">
                                                <div className="col-lg-5 col-md-5 col-12">
                                                    <h4 className="card-title mb-0">
                                                        Work Stations master
                                                    </h4>
                                                </div>
                                                <div className="col-lg-7 col-md-7 col-12">
                                                    <div className="d-flex justify-content-end align-items-center gap-2 flex-wrap">
                                                        {checkActionAuthorization("create", "Work Station") && (
                                                            <button
                                                                type="button"
                                                                className="btn btn-primary btn-md font-weight-medium"
                                                                onClick={handleAdd}
                                                            >
                                                                Add Work Station
                                                            </button>
                                                        )}
                                                        {checkActionAuthorization("upgrade", "Allow to Export Work Station") && (
                                                            <button
                                                                type="button"
                                                                className="btn btn-success btn-md font-weight-medium m-0 me-2"
                                                                onClick={fetchWorkStationCsvDetails}
                                                            >
                                                                Export Work Station
                                                            </button>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="d-flex justify-content-end mt-2">
                                                <span
                                                    className="resetFilters text-primary cursor-pointer"
                                                    onClick={resetFilters}
                                                >
                                                    Reset Filters
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mt-3">
                                        <div className="col">
                                            <DataTable
                                                value={workStationDetails}
                                                filterDisplay="row"
                                                scrollable
                                                sortField={filterReq.sortColumn}
                                                sortOrder={filterReq.sortOrder === "asce" ? 1 : -1}
                                                onSort={onTableSort}
                                                emptyMessage={"No work stations found"}
                                            >
                                                <Column
                                                    field="code"
                                                    header="STATION CODE"
                                                    sortable
                                                    filter
                                                    showFilterMenu={false}
                                                    filterElement={codeFilterTemplate}
                                                    style={{ minWidth: "220px", }}
                                                />
                                                <Column
                                                    field="name"
                                                    header="NAME"
                                                    sortable
                                                    filter
                                                    showFilterMenu={false}
                                                    filterElement={nameFilterTemplate}
                                                    style={{ minWidth: "300px", }}
                                                />
                                                <Column
                                                    field="workCenterCode"
                                                    header="WORK CENTRE"
                                                    sortable
                                                    filter
                                                    showFilterMenu={false}
                                                    filterElement={workCenterFilterTemplate}
                                                    style={{
                                                        minWidth:
                                                            "300px",
                                                    }}
                                                />
                                                <Column
                                                    field="isActive"
                                                    header="STATUS"
                                                    sortable
                                                    body={statusBodyTemplate}
                                                    filter
                                                    filterField="isActive"
                                                    showFilterMenu={false}
                                                    filterElement={statusRowFilterTemplate}
                                                    style={{ minWidth: "220px", }}
                                                />
                                                <Column
                                                    field="createdAt"
                                                    header="Date Created"
                                                    sortable
                                                    body={(rowData: WorkStationDetailsEntity) =>
                                                        rowData.createdAt
                                                            ? new Date(rowData.createdAt).toLocaleDateString("en-GB")
                                                            : "-"
                                                    }
                                                    style={{ minWidth: "200px" }}
                                                />
                                                {(checkActionAuthorization("update", "Work Station") || checkActionAuthorization("delete", "Work Station")) && (
                                                    <Column
                                                        header="Action"
                                                        body={actionIconTemplate}
                                                        style={{ minWidth: "220px", }}
                                                    />
                                                )}
                                            </DataTable>
                                        </div>
                                    </div>
                                    {!IsNullOrEmptyArray(workStationDetails) && (
                                        <div className="mt-3">
                                            <PrimePaginator
                                                onPageChange={onPageChange}
                                                pageNumber={filterReq.pageNumber}
                                                pageSize={filterReq.pageSize}
                                                totalRecords={totalPageCount}
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Dialog
                header={isEditMode ? "Edit Work Station" : "Add Work Station"}
                className="production-master-dialog"
                contentStyle={{ padding: "10px 20px 20px 20px", }}
                resizable={false}
                draggable={false}
                visible={isWorkStationDialogVisible}
                style={{ width: "650px", }}
                modal
                onHide={closeWorkStationDialog}
                footer={
                    <div className="d-flex justify-content-end gap-2">
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={closeWorkStationDialog}
                        >
                            Cancel
                        </button>

                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={handleSaveWorkStation}
                        >
                            {isEditMode ? "Update" : "Save"}
                        </button>
                    </div>
                }
            >
                <div className="row mt-3">
                    <div className="col-md-6">
                        <div className="form-group mb-3">
                            <label>
                                STATION CODE{" "}
                                <sup className="mandatory">
                                    *
                                </sup>
                            </label>
                            <InputText
                                id="workStationCode"
                                value={workStationCode}
                                maxLength={25}
                                className="form-control"
                                placeholder="Enter station code"
                                onChange={(e) => handleChange("code", e.target.value)}
                            />
                            {submitted && (
                                <small className="text-danger font-weight-500">{formErrors.code}</small>
                            )}
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group mb-3">
                            <label>
                                NAME{" "}
                                <sup className="mandatory">
                                    *
                                </sup>
                            </label>
                            <InputText
                                id="workStationName"
                                value={workStationName}
                                maxLength={50}
                                className="form-control"
                                placeholder="Enter name"
                                onChange={(e) => handleChange("name", e.target.value)}
                            />

                            {submitted && (
                                <small className="text-danger font-weight-500">                                    {formErrors.name}
                                </small>
                            )}

                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group mb-3">
                            <label>
                                WORK CENTRE{" "}
                                <sup className="mandatory">
                                    *
                                </sup>
                            </label>
                            <Dropdown
                                value={selectedWorkCenterId}
                                options={workCenterOptions}
                                optionLabel="label"
                                optionValue="value"
                                placeholder="Select work centre"
                                className="w-100"
                                onChange={(e) => handleWorkCenterChange(e.value)}
                            />
                            {submitted && (
                                <small className="text-danger font-weight-500">
                                    {formErrors.workCenter}
                                </small>
                            )}
                        </div>
                    </div>
                    {isEditMode && (
                        <div className="col-md-6">
                            <div className="form-group mb-3">
                                <label>
                                    STATUS
                                </label>
                                <div className="d-flex align-items-center mt-2">

                                    {Status.map((option: any) => (
                                        <div
                                            key={option.code}
                                            className="d-flex align-items-center me-4"
                                        >
                                            <RadioButton
                                                inputId={String(option.code)}
                                                name="status"
                                                className="me-2"
                                                value={option.code}
                                                onChange={(e) => setWorkStationIsActive(e.value)}
                                                checked={workStationIsActive === option.code}
                                            />
                                            <label htmlFor={String(option.code)}                                            >
                                                {option.name}
                                            </label>
                                        </div>
                                    )
                                    )}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </Dialog>
        </>
    );
}

export default WorkStation;